










































































































































import { Component, Vue } from 'vue-property-decorator';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';

import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';
import { AxiosError } from 'axios';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    SearchRow,
    SearchField,
    Select,
  },
  computed: mapState(['user']),
})
export default class AddMerchant extends Vue {
  user!: {
    user: User;
  };

  loadingSubmit = false;
  merchantName = '';
  picEmail = '';
  picPhone = '';
  merchantId = '';
  merchantSite = '';
  merchantType: LabelValue | null = null;
  merchantTypeOptions = [
    {
      label: 'Full Manual',
      value: '0',
    },
    {
      label: 'Semi Auto',
      value: '1',
    },
    {
      label: 'Full Auto',
      value: '2',
    },
  ]

  cancel() {
    this.$router.push('/easyinvoice/configuration/merchant');
  }

  async save() {
    try {
      this.loadingSubmit = true;
      if (this.merchantName === '') return;
      if (this.picEmail === '') return;
      if (this.picPhone === '') return;
      if (this.merchantId === '') return;
      if (this.merchantSite === '') return;
      const { data } = await api.post('/easyinvoice/merchants_add', {
        /* eslint-disable @typescript-eslint/camelcase */
        user_group: '0',
        merchant_name: this.merchantName,
        pic_email: this.picEmail,
        pic_phone: this.picPhone,
        merchant_id: this.merchantId,
        merchant_type: this.merchantType?.value,
        merchant_site: this.merchantSite,
        email_created_by: this.user.user.email,
        // email_created_by: 'indra.maulana@sprintasia.net',
      });
      if (data.status === '00') {
        this.loadingSubmit = false;
        showToast(ToastType.SUCCESS, 'Add Merchant Success', data.message);
        this.$router.push('/easyinvoice/configuration/merchant');
      } else if (data.status === '01') {
        this.loadingSubmit = false;
        showToast(ToastType.SUCCESS, 'Opps... Sorry', data.message);
      }
    } catch (error) {
      showToast(ToastType.FAILED, 'Opps... Sorry', 'Problem connection, Please check your internet connection');
      // showToast(ToastType.FAILED, 'Oops… Sorry', error.response.data.error.errors.map((e: any) => e.message));
      this.loadingSubmit = false;
      console.log(error);
    }
  }
}
